
import { z } from 'zod';

export const farmFormSchema = z.object({
  region: z.string().min(1, { message: 'Region is required' }),
  farm_size: z.coerce.number().positive({ message: 'Farm size must be a positive number' }),
  irrigation_type: z.string().nullable(),
  latitude: z.coerce.number().nullable(),
  longitude: z.coerce.number().nullable(),
  
  // Farmer information fields
  farmer_name: z.string().min(2, { message: 'Farmer name is required' }),
  phone_number: z.string().min(1, { message: 'Phone number is required' }),
  union_name: z.string().nullable().optional(),
  has_contract: z.boolean().default(false),
  has_phone_access: z.boolean().default(false),
  officer: z.string().nullable().optional(),
  product_name: z.string().min(1, { message: 'Product name is required' }),
  products: z.array(z.string()).optional(),
  distance_from_addis: z.coerce.number().default(0),
  
  // Location fields
  city: z.string().nullable().optional(),
  area: z.string().nullable().optional(),
  
  // Farm category field
  farm_category: z.enum(['Corporate Farm', 'Large Scale Farmer', 'Medium Scale Farmer', 'Small Holder Farmer'], {
    required_error: 'Farm category is required',
  }),
  
  // Coordinator tracking fields
  registered_by: z.string().optional(),
  coordinator_id: z.string().optional(),
  
  // Harvest date fields
  harvest_start_date: z.string().nullable().optional(),
  harvest_end_date: z.string().nullable().optional(),
  estimated_harvest_kg: z.coerce.number().nullable().optional(),
});

export type FarmFormValues = z.infer<typeof farmFormSchema>;
